export const AuthenticationTokens = {
  Identity: Symbol.for('shared.Identity'),
  AccessToken: Symbol.for('shared.AccessToken'),
};
